import React from "react"
import Skeleton from "react-loading-skeleton"
// loader
import 'react-loading-skeleton/dist/skeleton.css'
export const SalonInfoLoader = () => (
       <div className='home_main'>
        <div className='__left banner_image'>
            <Skeleton width={'100%'} height={'100%'} />
        </div>
       <div className='__right text_parent'>
         <div className='beu_logo hide-mobile'>
            <Skeleton />
         </div>
         <div className='__bottom'>
             <div className='client_logo'>
               <div className='logo hide-mobile'>
               <Skeleton />
               </div>
             </div>
             <h2 className='hide-mobile'><Skeleton /></h2>
             <p><Skeleton /></p>
           
         </div>
       </div>
     </div>
)
// Render a grid of placeholder staff cards so the skeleton matches the real
// _staff_parent_display flex-wrap layout (StaffWrapper.js:127). Six cards covers
// a typical salon without overfilling; cards wrap naturally on narrow screens.
export const StaffLoader = () => (
    <>
        {[0, 1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="_staff">
                <Skeleton className="circle-img" alt="staff" />
                <h6><Skeleton width={'80%'} /></h6>
            </div>
        ))}
    </>
)

// Matches the real Services page (Services.js:822-856): horizontal category
// tabs row + a scrollable body with multiple categories, each containing
// several service cards.
export const ServiceLoader = () => {
    const categories = [
        { tabWidth: 70, services: 4 },
        { tabWidth: 90, services: 3 },
    ];
    return (
        <>
            <ul className='services_tab pl-0'>
                {[70, 90, 60, 100, 80].map((w, i) => (
                    <li key={i}><p className="mb-0"><Skeleton width={w} /></p></li>
                ))}
            </ul>
            <div className='_service_parent_body'>
                {categories.map((cat, i) => (
                    <div key={i} className='_service_parent'>
                        <h3><Skeleton width={160} /></h3>
                        <div className='_service_body'>
                            {Array.from({ length: cat.services }).map((_, j) => (
                                <div key={j} className='____service'>
                                    <h6><Skeleton width={'80%'} /></h6>
                                    <div className='_bottom'>
                                        <p className='_time mb-0'><Skeleton width={40} /></p>
                                        <p className='_price mb-0'><Skeleton width={50} /></p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

// Matches the real booking slots layout (bookingSlots.js:2427-2600): three
// time-of-day sections (Morning/Afternoon/Evening), each an <h4> + wrapping
// grid of slot pills. The date picker above renders live while loading, so
// only the slots area needs a skeleton.
export const SlotLoader = () => {
    const sections = [
        { count: 8 },
        { count: 10 },
        { count: 6 },
    ];
    return (
        <div className="__booking_slot_time mt-4">
            {sections.map((section, i) => (
                <div key={i} className="_time_slot">
                    <h4><Skeleton width={110} /></h4>
                    <ul className="slot_parent">
                        {Array.from({ length: section.count }).map((_, j) => (
                            <li key={j}><Skeleton /></li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
}
 {/* <div className="notify-row cursor-point">
        <div className="profile-dp">
            <td><Skeleton circle={true} height={60} width={60} /></td>

        </div>
        <div className="message">
            <div>
                <h5><b className="mr-3"><Skeleton width={100} /> </b></h5>
                <Skeleton width={300} />
            </div>
            <div className="action_group  ">
                <span className="action_group  ">
                    <Skeleton height={50} width={150} />
                </span>
            </div>
        </div>
    </div > */}
    export const NewServiceSkeletop = ()=>(
        <div class="service-category mb-3 react-draggable">
            <>
            {/* <p className="mb-0"><Skeleton height="20px" width="100%" /></p> */}
             <div class="service-items">
                 <div class="service-item react-draggable" >
                     <div class="_text">
                         <p className="d-flex mb-0"><span className="mr-4"><Skeleton height="10px" width="60px" /></span><Skeleton height="10px" width="60px" /></p>
                         <p className="mb-0"><Skeleton height="20px" width="100%" /></p>
                     </div>
                 </div>
                 <div class="service-item react-draggable" >
                     <div class="_text">
                         <p className="d-flex mb-0"><span className="mr-4"><Skeleton height="10px" width="60px" /></span><Skeleton height="10px" width="60px" /></p>
                         <p className="mb-0"><Skeleton height="20px" width="100%" /></p>
                     </div>
                 </div>
                 <div class="service-item react-draggable" >
                     <div class="_text">
                         <p className="d-flex mb-0"><span className="mr-4"><Skeleton height="10px" width="60px" /></span><Skeleton height="10px" width="60px" /></p>
                         <p className="mb-0"><Skeleton height="20px" width="100%" /></p>
                     </div>
                 </div>
             </div>
             </>
        </div>
      )

